import { TweenMax } from 'gsap';
import { Animation } from '../../Animations/Animation';
import { UIButton } from './UIButton';

export class CollapsibleGroup extends PIXI.Container {
    public readonly collapseButton: UIButton;

    public get width() {
        return this.collapseButton.width * this.scale.x;
    }

    public get height() {
        return this.collapseButton.height * this.scale.y;
    }

    public get interactive() {
        return this.collapseButton.interactive;
    }

    public set interactive(value) {
        this.collapseButton.interactive = value;
    }

    public animate: boolean = true;

    public get isCollapsed() {
        return this.collapsed;
    }

    private collapsed: boolean = true;
    private openAnimation: Animation;
    private direction: PIXI.Point;
    private items: PIXI.Container[] = [];

    constructor(collapseButton: UIButton, direction: PIXI.Point = new PIXI.Point(1, 0)) {
        super();
        this.collapseButton = collapseButton;
        this.direction = direction;
        this.openAnimation = new Animation({});
        collapseButton.on(UIButton.events.Trigger, () => this.setCollapsed(!this.collapsed));
        this.addChild(collapseButton);
    }

    public addItem(item: PIXI.Container) {
        if (this.items.includes(item)) {
            return;
        }
        this.items.push(item);
        this.addChildAt(item, 0);
        item.visible = false;
        item.alpha = 0;
        this.rebuildOpenAnimation();
    }

    public removeItem(item: PIXI.Container) {
        const index = this.items.indexOf(item);
        if (index === -1) {
            return index;
        }
        item.visible = false;
        this.items.splice(index, 1);
        this.rebuildOpenAnimation();
        return index;
    }

    public async setCollapsed(collapsed: boolean) {
        this.collapsed = collapsed;
        if (collapsed) {
            await this.openAnimation.reversed();
        } else {
            await this.openAnimation.play();
        }
    }

    private rebuildOpenAnimation() {
        if (this.openAnimation) {
            this.openAnimation.destroy();
        }
        this.openAnimation = new Animation({});
        const { openAnimation, direction, items, collapseButton } = this;
        const totalDimensions = new PIXI.Point();
        totalDimensions.x = collapseButton.width / 2;
        totalDimensions.y = collapseButton.height / 2;
        for (const item of items) {
            totalDimensions.x += item.width / 2;
            totalDimensions.y += item.height / 2;

            const targetPostion = direction.clone();
            targetPostion.x *= totalDimensions.x;
            targetPostion.y *= totalDimensions.y;
            openAnimation.addToLast(() => (item.visible = true));
            openAnimation.addToLast(
                TweenMax.fromTo(
                    item,
                    0.2,
                    { x: 0, y: 0 },
                    { x: targetPostion.x, y: targetPostion.y }
                )
            );
            openAnimation.addToLast(TweenMax.fromTo(item, 0.1, { alpha: 0 }, { alpha: 1 }));

            totalDimensions.x += item.width / 2;
            totalDimensions.y += item.height / 2;
        }
    }
}
